<div class="pt-4 flex flex-col gap-4">

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.meta-description' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-text-editor
        [nl]="form.controls.metaDescriptionNl"
        [en]="form.controls.metaDescriptionEn"
        [de]="form.controls.metaDescriptionDe"
        [it]="form.controls.metaDescriptionIt"
        [fr]="form.controls.metaDescriptionFr"
      />
    </mat-card-content>
  </mat-card>

</div>
